<template>
  <svg
    class="status-spinner"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke-width="2.5"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <path d="M21 12a9 9 0 1 1-6.2-8.6" />
  </svg>
</template>

<script>
export default {
  name: "StatusSpinner",
  props: {
    size: {
      type: Number,
      default: 13,
    },
  },
};
</script>

<style lang="scss" scoped>
.status-spinner {
  flex-shrink: 0;
  stroke: var(--oliver-accent);
  animation: status-spin 0.9s linear infinite;
}

@keyframes status-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .status-spinner {
    animation-duration: 2.4s;
  }
}
</style>
